<template>
  <va-dropdown
    class="contact-dropdown"
    offset="0, 16px"
    fixed>

    <img slot="anchor" class="contact-section-avatar-container" src="static/icons/phone-mail.svg">

    <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">
      <div class="contact-dropdown__item row align--center pt-1 pb-1 mt-2 mb-2"
         v-for="(option, id) in options"
         :key="id"
      >
        <a :href="option.url" class="plain-link long">
          <img :src="option.icon">
          {{ option.text }}
        </a>
      </div>
    </div>
  </va-dropdown>
</template>

<script>

export default {
  name: 'contact-dropdown',
  props: {
    options: {
      type: Array,
      default: () => [
        {
          icon: 'static/icons/mail.svg',
          text: 'suporte@evollu.com',
          url: 'mailto:suporte@evollu.com'
        },
        {
          icon: 'static/icons/phone.svg',
          text: '+351 933 420 073',
          url: 'tel:+351933420073'
        },
      ],
    },
  },
}
</script>

<style lang="scss">

.contact-dropdown {
  cursor: pointer;

  .contact-section-avatar-container {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 50%;
    border: 2px solid $lighter-gray;
    overflow: hidden;
    img {
      height:16px;
      //margin-top:6px;
      //margin-left:2px;
    }
  }

  &__item {
    // height: 48px;
    cursor: pointer;
    font-size: 1rem;
    img {
      height: 18px;
      margin-right: 10px;
      margin-bottom: -5px;
      margin-left: 2px;
    }
    a {
      color: #414141;
    }
  }

  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 13rem;
  }
  &__item {
    padding-bottom: 0.625rem;
    cursor: pointer;
    flex-wrap: nowrap;
    &:last-of-type {
      padding-bottom: 0 !important;
    }
    &:hover, &.active {
      a {
        color: $vue-green !important;
      }
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
  }
}
</style>
